export const GET_NON_PPC_MC_SETTINGS_PENDING = 'GET_NON_PPC_MC_SETTINGS_PENDING';
export const GET_NON_PPC_MC_SETTINGS_FULFILLED = 'GET_NON_PPC_MC_SETTINGS_FULFILLED';
export const GET_NON_PPC_MC_SETTINGS_REJECTED = 'GET_NON_PPC_MC_SETTINGS_REJECTED';

const initialState = {
  point_redemption_date: '',
  point_redemption_dates: [],
  fetching: false,
  fetched: false
};

export default function nonPpcMcSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_NON_PPC_MC_SETTINGS_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_NON_PPC_MC_SETTINGS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
      };
    }
    case GET_NON_PPC_MC_SETTINGS_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      };
    }
    default:
      return state;
  }
}
